
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { LedgerPostType } from 'enums/LedgerPostType';
import { Model, ModelProperty } from 'models/Model';


export class LedgerPostSearchModel extends Model<LedgerPostSearchModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'maxPlannedDate', type: 'Date', languageString: 'ledgerPostSearch.property.maxPlannedDate' },
		{ name: 'types', type: 'LedgerPostType[]', languageString: 'ledgerPostSearch.property.types', isArray: true },
		{ name: 'brandId', type: 'guid', languageString: 'ledgerPostSearch.property.brandId' }
	];
	[key: string]: any;
	
	public maxPlannedDate?: Date;
	public types: LedgerPostType[];
	public brandId?: string;
    
	constructor(){
		super();
		this.maxPlannedDate = undefined;
		this.types = [];
		this.brandId = undefined;
		
	}
	getProperties(){
		return LedgerPostSearchModel.classProperties;
	}
}

